module.exports = __webpack_public_path__ + "static/logo-master-2fabc26f7df75a4df5ec6fc81e5acae2.png";